import { ApplicationRef, createComponent, DOCUMENT, EnvironmentInjector, inject, Injectable } from '@angular/core';
import { ShSnackbarComponent } from '../components/wrappers/sh-snackbar/sh-snackbar.component';

export interface ShSnackbarOptions {
    title?: string;
    description: string;
    type?: 'info' | 'success' | 'error' | 'warning';
    duration?: number;
    position?: 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right';
}

@Injectable({ providedIn: 'root' })
export class ShSnackbarService {
    private readonly document = inject(DOCUMENT);
    private readonly appRef = inject(ApplicationRef);
    private readonly environmentInjector = inject(EnvironmentInjector);

    public open(options: ShSnackbarOptions): void {
        const hostElement = this.document.createElement('sh-snackbar');
        const label = options.title ? `${options.title}: ${options.description}` : options.description;
        const componentRef = createComponent(ShSnackbarComponent, {
            environmentInjector: this.environmentInjector,
            hostElement
        });

        componentRef.setInput('label', label);
        componentRef.setInput('type', options.type ?? 'info');
        componentRef.setInput('position', options.position ?? 'bottom-center');
        componentRef.setInput('timeout', options.duration ?? 4000);
        componentRef.setInput('dismissible', true);
        componentRef.setInput('accessibleCloseLabel', 'Close notification');
        componentRef.instance.dismissed.subscribe(() => {
            this.appRef.detachView(componentRef.hostView);
            componentRef.destroy();
        });

        this.appRef.attachView(componentRef.hostView);
        this.document.body.appendChild(hostElement);
    }
}
